export default __webpack_public_path__ + "static/media/17.72ad0d20.jpg";